import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Multiselect property component for select fields
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MultiselectProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'select') {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertyGroup, {
    children: /*#__PURE__*/_jsxs("label", {
      className: "checkbox-label",
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: field.multiselect || false,
        onChange: e => updateField(selectedField, {
          multiselect: e.target.checked
        })
      }), "Enable Multiple Selection"]
    })
  });
};